'use client'

import { useEffect } from 'react'
import { useSearchParams, usePathname, useRouter } from 'next/navigation'
import { useBookingBarStore } from '@/lib/context/bookingBarContext'

const GlobalOfferClient = ({
  promo,
  hotelIds,
}: {
  promo?: string | null
  hotelIds: number[] | null | undefined
}) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const { setFilter } = useBookingBarStore()

  useEffect(() => {
    if (promo && searchParams.get('promo') !== promo) {
      const params = new URLSearchParams(searchParams.toString())
      params.set('promo', promo)
      router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    }
  }, [promo, searchParams, pathname, router])

  useEffect(() => {
    if (hotelIds && hotelIds?.length > 0) {
      setFilter(hotelIds)
    }

    return () => {
      setFilter(null)
    }
  }, [hotelIds])

  return null
}

export default GlobalOfferClient
